import { Col, Row } from "reactstrap";
import PageImage from "../../CommonComponents/PageImage";
import BlogDetails from "../RightSidebar/BlogDetails";
import Sidebar from "../RightSidebar/Sidebar";

const LeftSidebarContainer = () => {
  return (
    <section className="section-py-space blog-page ratio2_3">
      <PageImage/>
      <div className="custom-container">
        <div className="blog-sidebar">
          <Row className="g-4">
            <Col xl="3" lg="12">
              <div className="blog-sidebar">
                <div className="blog-card">
                  <Sidebar />
                </div>
              </div>
            </Col>
            <Col xl="9" lg="12">
              <div className="blog-card">
                <BlogDetails />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </section>
  );
};

export default LeftSidebarContainer;
